/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getPublicQrCodeScanToken.internal

import features.getPublicQrCodeScanToken.models.GetPublicQrCodeScanTokenResponseModel
import features.getPublicQrCodeScanToken.models.PublicQrCodeScanTokenRequest
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.getPublicQrCodeScanToken.internal.GetPublicQrCodeScanTokenUseCase.Params

internal class GetPublicQrCodeScanTokenUseCase : AsyncUseCase<GetPublicQrCodeScanTokenResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val publicQrCodeScanTokenRequest: PublicQrCodeScanTokenRequest
    )

    private val getPublicQrCodeScanTokenService: GetPublicQrCodeScanTokenService = GetPublicQrCodeScanTokenServiceImpl()

    override suspend fun run(params: Params): Result<GetPublicQrCodeScanTokenResponseModel> {
        return getPublicQrCodeScanTokenService.getPublicQrCodeScanToken(
            overrideHeaders = params.overrideHeaders,
            publicQrCodeScanTokenRequest = params.publicQrCodeScanTokenRequest
        )
    }
}
